import { APP_LOGO } from "@/const";
import { Button } from "@/components/ui/button";

export default function Header() {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/98 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="container">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img 
              src={APP_LOGO} 
              alt="Suite Global Estate" 
              className="h-12 w-auto"
            />
          </div>
          <Button 
            size="lg" 
            className="font-semibold text-sm md:text-base px-4 md:px-6"
            onClick={scrollToForm}
          >
            <span className="hidden sm:inline">Get Free Consultation</span>
            <span className="sm:hidden">Contact</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
